/**
 * @generated SignedSource<<552b0298ab8454a1a4a5994c151f1454>>
 * @relayHash e80d65c45d7b18d045adb2f8bae28ff2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 580eec98844789db08cf44933c1481969b1fe216204014879b615e5fdaed89e4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalBrandingQuery } from './GlobalBrandingQuery.graphql';

const node: PreloadableConcreteRequest<GlobalBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "580eec98844789db08cf44933c1481969b1fe216204014879b615e5fdaed89e4",
    "metadata": {},
    "name": "GlobalBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
